import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import Header from "../../components/Header";
import connect from "react-redux/es/connect/connect";
import DishesList from "./DishesList";
import SearchField from "../Field";
import DishFilters from "../Filters";
import Button from "@material-ui/core/Button/Button";
import { FilterList, KeyboardArrowLeft } from "@material-ui/icons";
import {client} from "../../config/apollo";
import {DISHES_BY_CHEF, FIND_DISHES} from "../../graphql/queries/dishes";
import { getDishFilters, setDishSearchByName } from "../../redux/chefs";
import Breadcrumbs from "../Breadcrumbs";

class Dishes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openFilters: false,
      filters: {},
      reset: false,
      showMessage: false,
      searchVal: '',
      dishesList: []
    };
    this.child = React.createRef();
  }

  searchByName = search => {
    this.setState({ filters: { search: search } });
    this.props.dispatch(setDishSearchByName(search));
  };

  componentDidMount() {
    const { dispatch, dishSearchName } = this.props;
    dispatch(getDishFilters());

    if (dishSearchName && dishSearchName.length > 2) {
      this.searchByName(dishSearchName);
      if (document.getElementById('dish-search')) {
        document.getElementById('dish-search').value = dishSearchName;
      }
    }
  }

  applyFilters = filters => {
    const {
      engagement: engagementSize,
      priceMin,
      priceMax,
      cuisines,
      dishes,
      dishTypes
    } = filters;

    const updateFilters = {
      engagementSize
    };

    if (priceMin !== 5 && priceMax !== 10000) {
      updateFilters.priceMin = priceMin;
      updateFilters.priceMax = priceMax;
    }

    if (cuisines.length) {
      updateFilters.cuisines = cuisines;
    }

    if (dishes.length) {
      updateFilters.dishes = dishes;
    }

    if (dishTypes.length) {
      updateFilters.dishTypes = dishTypes;
    }
    this.setState({
      openFilters: false,
      filters: updateFilters
    });
    if (this.child)
      this.child.fetchAll();
  };

  render() {
    const { dishSearchName } = this.props;
    const search =
      (this.props.location.state && this.props.location.state.search) ||
      (this.props.location && this.props.location.search) ||
      dishSearchName && dishSearchName.length >= 2 ? dishSearchName : '';

    const isLiveShow =
      (this.props.location.state && this.props.location.state.isLiveShow) || false;

    let name = "";
    const { filters: myFilters } = this.state;
    const { isChef } = this.props;

    let filters =
      search.length > 0
        ? { ...myFilters, search: myFilters.search || search }
        : { chefId: this.props.userId };

    if (!!myFilters.search && myFilters.search.length > 0 && myFilters.search !== 'a') {
      filters.search = myFilters.search;
    }

    return (
      <div >
        <Header {...this.props} />
        <div style={{margin: '0 30px'}}>
        <Grid container className="custom-setting">
          <div className="chef-details-bc" style={{ display: 'flex', justifyContent: 'space-between', maxWidth: 1130, width: '100%'}}>
            <div>
              <Breadcrumbs childRoutes={[
                {
                  display: 'Dishes',
                  link: 'home/dish-search'
                }
              ]} />
            </div>
            <div>
              {!isChef && <Grid container className="dish-container" alignContent={"flex-end"} justify={"flex-end"}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                {this.state.showMessage && <div style={{ color: '#ff8000', marginBottom: 10 }}>Press Enter key to search</div>}
                <SearchField
                  id="dish-search"
                  type={"search"}
                  placeholder={"Search dishes"}
                  onChange={evt => {
                    name = evt.target.value;
                    this.setState({ searchVal: evt.target.value });
                  }}
                  onKeyDown ={evt => {
                    if (evt.key === 'Backspace') {
                      // this.searchByName(name.length > 2 ? name : 'a');
                    }
                    if (this.state.searchVal.length > 1) {
                      this.setState({ showMessage: true });
                    } else { this.setState({ showMessage: false }); }
                  }}
                  onKeyPress={evt => {
                    if (evt.key === "Enter") {
                      this.searchByName(this.state.searchVal);
                    }

                    if (this.state.searchVal.trim().length > 1) {
                      this.setState({ showMessage: true });
                    } else { this.setState({ showMessage: false }); }
                  }}
                />
                </div>
              </Grid>}
            </div>
          </div>
          {this.props.userId && (
            <DishesList
              onRef={ref => {
                this.child = ref;
              } }
              type={search || (this.props.location && this.props.location.calledFrom === 'footer') ? "all" : "dishesByChef"}
              pageSize={1000}
              isLiveShow={isLiveShow}
              filters={filters}
              next={null}
              previous={null}
              searching={true}
              {...this.props}
            />
          )}
        </Grid>
        <DishFilters
          dishes
          openFiltersDrawer={this.state.openFilters}
          onApplyFilters={this.applyFilters}
          closeFilters={() => this.setState({ openFilters: false })}
        />
          {!isChef && <Button
           data-test-id={"searchdishbtn-id"}
          color={"primary"}
          variant={"contained"}
          style={{
            height: 150,
            width: 10,
            borderRadius: 15,
            position: "fixed",
            top: "50%",
            left: "-15px",
            zIndex: 99999
          }}
          onClick={() =>
            this.setState({ openFilters: !this.state.openFilters })
          }
        >
          {this.state.openFilters && (
            <KeyboardArrowLeft data-test-id={"searchdishbtna-id"} style={{ fontSize: 40, color: "white" }} />
          )}
          {!this.state.openFilters && (
            <FilterList data-test-id={"searchdishbtnb-id"} style={{ fontSize: 32, color: "white", marginLeft: 3 }} />
          )}
        </Button>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isChef: state.auth.isChef,
    userId: state.auth.userId,
    dishSearchName: state.chefs.dishSearchName
  };
};
const DishSearch = connect(mapStateToProps)(Dishes);

export default DishSearch;
